"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const ProcessListItem_1 = __importDefault(require("./ProcessListItem"));
const ProcessListItemHeader_1 = __importDefault(require("./ProcessListItemHeader"));
const ProcessListComponent = (0, react_1.forwardRef)(({ children, className, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("ol", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-process-list', className), ...props, children: children }));
});
const ProcessList = Object.assign(ProcessListComponent, { Item: ProcessListItem_1.default, ItemHeader: ProcessListItemHeader_1.default });
exports.default = ProcessList;
